import { QuoteInternalNote } from '../models';
import { useDocument } from './useDocument';

export function useQuoteInternalNote(
  quoteId: string,
  id: string | 'new' = 'new'
) {
  return useDocument<QuoteInternalNote>(`/Quotes/${quoteId}/InternalNotes`, id);
}
